import styled from '@emotion/styled'
import { css } from '@emotion/react'

// Theses are the styles you would want to override to add whatever section to the right sides of the footer.

export const TopSection = styled.div(
  ({ theme }) => css`
    @media (max-width: ${theme.breakpoints.md}) {
      margin-top: ${theme.spacing.md};
      width: 100%;
    }
  `
)

export const BottomSection = styled.div`
  flex: 2;

  h3 {
    font-weight: 500;
  }
`
